import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"],
  _excluded2 = ["option"];
import { QuestionIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { AREA, BAR, COLUMN, DATA_WELL, DONUT, FUNNEL, GAUGE, LINE, PIE, SANKEY, TABLE } from 'reporting-data/constants/chartTypes';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';

// @ts-expect-error Untyped import
import AreaChartIcon from 'reporting-ui-components/components/shared/icons/AreaChartIcon';
// @ts-expect-error Untyped import
import BarChartIcon from 'reporting-ui-components/components/shared/icons/BarChartIcon';
// @ts-expect-error Untyped import
import ColumnChartIcon from 'reporting-ui-components/components/shared/icons/ColumnChartIcon';
// @ts-expect-error Untyped import
import DataWellChartIcon from 'reporting-ui-components/components/shared/icons/DataWellChartIcon';
// @ts-expect-error Untyped import
import DonutChartIcon from 'reporting-ui-components/components/shared/icons/DonutChartIcon';
// @ts-expect-error Untyped import
import LineChartIcon from 'reporting-ui-components/components/shared/icons/LineChartIcon';
// @ts-expect-error Untyped import
import PieChartIcon from 'reporting-ui-components/components/shared/icons/PieChartIcon';
// @ts-expect-error Untyped import
import TableChartIcon from 'reporting-ui-components/components/shared/icons/TableChartIcon';
// @ts-expect-error Untyped import
import SankeyChartIcon from 'reporting-ui-components/components/shared/icons/SankeyChartIcon';
// @ts-expect-error Untyped import
import FunnelChartIcon from 'reporting-ui-components/components/shared/icons/FunnelChartIcon';
// @ts-expect-error Untyped import
import ScatterChartIcon from 'reporting-ui-components/components/shared/icons/ScatterChartIcon';
// @ts-expect-error Untyped import
import CombinationChartIcon from 'reporting-ui-components/components/shared/icons/CombinationChartIcon';
// @ts-expect-error Untyped import
import PivotTableChartIcon from 'reporting-ui-components/components/shared/icons/PivotTableChartIcon';
// @ts-expect-error Untyped import
import GaugeChartIcon from 'reporting-ui-components/components/shared/icons/GaugeChartIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CHART_TYPE_ICON_MAP = {
  [AREA]: AreaChartIcon,
  [BAR]: BarChartIcon,
  [COLUMN]: ColumnChartIcon,
  [DATA_WELL]: DataWellChartIcon,
  [DONUT]: DonutChartIcon,
  [FUNNEL]: FunnelChartIcon,
  [LINE]: LineChartIcon,
  [PIE]: PieChartIcon,
  [SANKEY]: SankeyChartIcon,
  [TABLE]: TableChartIcon,
  [VisualTypes.VERTICAL_BAR]: ColumnChartIcon,
  [VisualTypes.HORIZONTAL_BAR]: BarChartIcon,
  [VisualTypes.SCATTER]: ScatterChartIcon,
  [VisualTypes.TEXT]: DataWellChartIcon,
  [VisualTypes.COMBO]: CombinationChartIcon,
  [VisualTypes.PIVOT_TABLE]: PivotTableChartIcon,
  [GAUGE]: GaugeChartIcon
};
export const DEFAULT_CHART_ICON = () => /*#__PURE__*/_jsx(QuestionIcon, {
  size: "100"
});
export const ChartTypeToggleOptionComponent = _ref => {
  let {
      option: {
        text,
        value: chartType
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ChartTypeIcon = chartType in CHART_TYPE_ICON_MAP ? CHART_TYPE_ICON_MAP[chartType] : DEFAULT_CHART_ICON;
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "start",
      gap: "200",
      paddingInline: "500",
      paddingBlock: "200",
      children: [/*#__PURE__*/_jsx(ChartTypeIcon, {
        size: 20
      }), /*#__PURE__*/_jsx(_Fragment, {
        children: text
      })]
    })
  }));
};
export const SelectedChartTypeToggleOptionComponent = _ref2 => {
  let {
      option: {
        text,
        value: chartType
      }
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const ChartTypeIcon = chartType in CHART_TYPE_ICON_MAP ? CHART_TYPE_ICON_MAP[chartType] : DEFAULT_CHART_ICON;
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "start",
      gap: "200",
      children: [/*#__PURE__*/_jsx(ChartTypeIcon, {
        size: 20
      }), /*#__PURE__*/_jsx(_Fragment, {
        children: text
      })]
    })
  }));
};